import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AuthLayout } from './layouts/AuthLayout';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { VerifyEmailPage } from './pages/VerifyEmailPage';
import { MfaPage } from './pages/MfaPage';
import { ConsentPage } from './pages/ConsentPage';
import { SocialSignupPage } from './pages/SocialSignupPage';
import { MfaResetPage } from './pages/MfaResetPage';
import { MfaEnrolmentPage } from './pages/MfaEnrolmentPage';
import { AccountPage } from './pages/AccountPage';
import { ProductsPage } from './pages/ProductsPage';
import { EspacePage } from './pages/EspacePage';
import { InvitationPage } from './pages/InvitationPage';
import { ErrorPage } from './pages/ErrorPage';
import { LogoutPage } from './pages/LogoutPage';
import { SupportSuiviPage } from './pages/SupportSuiviPage';
import { ConfirmerAdressePage } from './pages/ConfirmerAdressePage';
import { SuppressionComptePage } from './pages/SuppressionComptePage';
import { ChangerMotDePassePage } from './pages/ChangerMotDePassePage';
import { AdminLayout } from './admin/AdminLayout';
import { AdminTicketsPage } from './admin/AdminTicketsPage.jsx';
import { AdminEquipePage } from './admin/AdminEquipePage';
import { AdminComptesPage } from './admin/AdminComptesPage';
import { AdminCataloguePage } from './admin/catalogue/AdminCataloguePage.jsx';
import { AdminSuitePage } from './admin/catalogue/AdminSuitePage.jsx';
import { AdminOuverturePage } from './admin/ouverture/AdminOuverturePage.jsx';
import { AdminBetaPage } from './admin/beta/AdminBetaPage.jsx';
import { AdminQuestionsPage } from './admin/questions/AdminQuestionsPage.jsx';
import { AdminReferentielsPage } from './admin/referentiels/AdminReferentielsPage';
import { BienvenuePage } from './pages/dossiers/BienvenuePage';
import { NouveauDossierPage } from './pages/dossiers/NouveauDossierPage';
import { CreationDossierPage } from './pages/dossiers/CreationDossierPage';
import { FormulaireDossierPage } from './pages/dossiers/FormulaireDossierPage';
import { AbonnementsPage } from './pages/abonnements/AbonnementsPage';
import { AbonnementRetourPage } from './pages/abonnements/AbonnementRetourPage';

export const router = createBrowserRouter([
  // Back-office de la suite (27/09/2026) : sa propre mise en page, hors de la
  // carte centrée des écrans de connexion.
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      { index: true, element: <Navigate to="/admin/tickets" replace /> },
      { path: 'tickets', element: <AdminTicketsPage /> },
      { path: 'equipe', element: <AdminEquipePage /> },
      // Comptes clients : recherche, suspension (04/10/2026, ZO-AUTH-06).
      { path: 'comptes', element: <AdminComptesPage /> },
      // Ce qui est COMMUN aux produits (27/09/2026) : catalogue, produits, ouverture.
      { path: 'catalogue', element: <AdminCataloguePage /> },
      { path: 'produits', element: <AdminSuitePage /> },
      { path: 'ouverture', element: <AdminOuverturePage /> },
      // Version bêta des produits (03/10/2026).
      { path: 'beta', element: <AdminBetaPage /> },
      // Questionnaire de dossier commun à la suite (11/10/2026).
      { path: 'questions-dossier', element: <AdminQuestionsPage /> },
      // Référentiels : communes, codes APE (NAF rév. 2 / NAF 2025)… (14/10/2026).
      { path: 'referentiels', element: <AdminReferentielsPage /> },
    ],
  },
  {
    element: <AuthLayout />,
    children: [
      { path: '/', element: <Navigate to="/login" replace /> },
      { path: '/login', element: <LoginPage /> },
      { path: '/register', element: <RegisterPage /> },
      { path: '/mot-de-passe-oublie', element: <ForgotPasswordPage /> },
      { path: '/reinitialiser', element: <ResetPasswordPage /> },
      { path: '/verification', element: <VerifyEmailPage /> },
      // Compte à l'adresse jamais confirmée : la connexion renvoie ici (27/09/2026).
      { path: '/confirmer-adresse', element: <ConfirmerAdressePage /> },
      { path: '/mfa', element: <MfaPage /> },
      { path: '/mfa-reinitialisation', element: <MfaResetPage /> },
      { path: '/double-authentification', element: <MfaEnrolmentPage /> },
      { path: '/consentement', element: <ConsentPage /> },
      // Confirmation d'inscription par fournisseur externe : l'API renvoie en
      // `/inscription-<fournisseur>` ; le fournisseur est relu côté API.
      { path: '/inscription-google', element: <SocialSignupPage /> },
      { path: '/inscription-microsoft', element: <SocialSignupPage /> },
      { path: '/inscription-apple', element: <SocialSignupPage /> },
      { path: '/compte', element: <AccountPage /> },
      // Suppression du compte SANS l'appli (Google Play, 01/10/2026) : la page
      // publique semply.fr/suppression-compte renvoie ici.
      { path: '/compte/suppression', element: <SuppressionComptePage /> },
      // Changer son mot de passe, connecté (04/10/2026) — lien depuis les outils.
      { path: '/compte/mot-de-passe', element: <ChangerMotDePassePage /> },
      { path: '/produits', element: <ProductsPage /> },
      { path: '/espace', element: <EspacePage /> },
      { path: '/invitation', element: <InvitationPage /> },
      // Création et modification de dossier (11/10/2026, docs/creation-dossier.md).
      { path: '/bienvenue', element: <BienvenuePage /> },
      { path: '/dossiers/nouveau', element: <NouveauDossierPage /> },
      { path: '/dossiers/creation/:id', element: <CreationDossierPage /> },
      { path: '/dossiers/:companyId', element: <FormulaireDossierPage /> },
      // Formules, abonnements et packs de toute la suite (11/10/2026).
      { path: '/abonnements', element: <AbonnementsPage /> },
      { path: '/abonnements/retour', element: <AbonnementRetourPage /> },
      { path: '/deconnexion', element: <LogoutPage /> },
      // Suivi d'une demande par son lien. PUBLIQUE : le jeton du fragment est
      // l'autorisation, et exiger une session ici fermerait la porte au
      // visiteur sans compte — celui qui a le plus besoin qu'on lui réponde.
      // Déclarée avant le `*` pour ne pas tomber dans la page d'erreur.
      { path: '/support/:ref', element: <SupportSuiviPage /> },
      { path: '/erreur', element: <ErrorPage /> },
      { path: '*', element: <ErrorPage /> },
    ],
  },
]);
